import samPic from "@/public/images/artists/sam.png";
import { Artist } from "@/types/types";

export const sam = {
  id: "274",
  name: "Sam",
  image: samPic,
  description: `Sam's voice is big and resonant, with a vintage jazz tone and texture that lands from the first note.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fsam-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Male",
    tags: {
      primary: ["Unprocessed", "Deep", "Mature", "Blues", "Jazz", "Soundtrack"],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "Bass",
        high: "Mid",
      },
      specific: {
        low: 41,
        high: 64,
      },
      sweetSpot: 54,
    },
  },
} as const satisfies Artist;
